/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneVideoTranscript as ResolvedStandaloneVideoTranscript } from 'base/components/standalone/VideoTranscript';

export const VideoTranscript: typeof ResolvedStandaloneVideoTranscript = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneVideoTranscript {...props} />
        </ErrorBoundary>
    );
});

export type VideoTranscriptProps = PropsFromComponent<typeof VideoTranscript>;

/** @deprecated Use slot architecture instead */
export const VideoTranscriptWith = (extras: DynamicStandaloneExtras): typeof VideoTranscript => {
    return function VideoTranscript(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'VideoTranscript');
        return <ResolvedStandaloneVideoTranscript {...mergeProps({ options: { theme } }, props)} />;
    }
}